module.exports = __webpack_public_path__ + "static/19-9b8537ac36e54e75ff7c6efc151e4c26.png";